import { _js, ___p } from '@ifixit/localize';
import { color, space, fontSize, lineHeight } from '@ifixit/primitives';
import styled from 'styled-components';
import { PageReference } from './document_meta_types';
import Accordion from './accordion';

type ReferencesAccordionProps = {
   refs: PageReference[];
};

const ReferenceList = styled.ul`
   display: flex;
   flex-direction: column;
   margin: 0;
   padding: 0 ${space[5]};
`;

const Reference = styled.a`
   display: flex;
   flex-flow: row wrap;
   justify-content: space-between;
   padding: ${space[3]} 0;
   font-size: ${fontSize.md};
   line-height: ${lineHeight.tight};

   span {
      color: ${color.gray[500]};
   }

   &,
   &:hover {
      text-decoration: none;
      color: ${color.gray[800]};
   }
`;

const ReferencesAccordion = ({ refs }: ReferencesAccordionProps) => {
   if (refs.length <= 0) {
      return null;
   }
   const title = _js('References');
   const subtitle = ___p(refs.length, '%1 Reference', '%1 References', `${refs.length}`);

   return (
      <Accordion title={title} subtitle={subtitle}>
         <ReferenceList>
            {refs.map(ref => (
               <Reference key={ref.url} href={ref.url}>
                  {ref.title}
                  <span>view</span>
               </Reference>
            ))}
         </ReferenceList>
      </Accordion>
   );
};
export default ReferencesAccordion;
